module.exports = __webpack_public_path__ + "static/media/batman@2x.ab83ef3b.png";